import { Col, Row, Radio, DatePicker, Button } from "antd";
import React, { useEffect, useState } from "react";
import Charts from "./chart";
const { RangePicker } = DatePicker;

export default () => {
  const [value, setValue] = useState("month");
  const [loading, setLoading] = useState(false);
  const [date, setDate] = useState([]);
  const [chartData, setChartData] = useState([]);

  useEffect(() => {
    setChartData([1, 2, 3]);
  }, []);

  const reset = () => {
    setDate([]);
    setValue("month");
  };

  return (
    <div className="revenue" style={{ padding: 10 }}>
      <Row gutter={20}>
        <Col span={4}>
          <Radio.Group
            style={{ width: "100%" }}
            value={value}
            onChange={(e) => setValue(e.target.value)}
            optionType="button"
            buttonStyle="solid"
          >
            <Radio.Button className="button-children" value="month">
              月
            </Radio.Button>
            <Radio.Button className="button-children" value="square">
              季度
            </Radio.Button>
            <Radio.Button className="button-children" value="year">
              年
            </Radio.Button>
          </Radio.Group>
        </Col>
        <Col span={6}>
          开始日期：
          <RangePicker value={date} onChange={(e) => setDate(e)} />
        </Col>
        <Col span={4}>
          <Button onClick={reset}>重置</Button>
          <Button type="primary" loading={loading} style={{ marginLeft: 8 }}>
            查询
          </Button>
        </Col>
      </Row>
      <div style={{ height: 500, marginTop: 20 }}>
        <Charts data={chartData} height={500} />
      </div>
    </div>
  );
};
